
export default (https) => ({
  async getSaleReport(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/reports/sale?${queryString}`);
    return response.data;
  },
  async getPurchaseReport(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/reports/purchase?${queryString}`);
    return response.data;
  },
  async getProductionReport(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/reports/production?${queryString}`);
    return response.data;
  },

  async getPartsInProductsReport(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/reports/parts-in-products?${queryString}`);
    return response.data;
  },

  async exportPartsInProducts(payload) {
    const response = await https.post('/reports/parts-in-products/export', payload);
    return response;
  },

});
